var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#E5F5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 52.4L42.0114 61.3054C42.4009 61.6903 43.0277 61.6903 43.4172 61.3054L67 38",
    stroke: "#55C377",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSuccess);
export default __webpack_public_path__ + "static/media/modal_success.a1caecdbd8ba6fc6d5b51400ba319ded.svg";
export { ForwardRef as ReactComponent };